import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=5284e631"
import script from "./invoice.vue?vue&type=script&lang=ts"
export * from "./invoice.vue?vue&type=script&lang=ts"
import style0 from "./invoice.vue?vue&type=style&index=0&id=5284e631&prod&lang=stylus"
import style1 from "./invoice.vue?vue&type=style&index=1&id=5284e631&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports